import { gql } from '@apollo/client';

export const UPDATE_DOOR_WITH_OFFICE_MODE = gql`
  mutation UpdateDoorWithOfficeMode($doorId: ID!, $name: String!, $officeMode: UpdateDoorOfficeModeInput) {
    updateDoor(doorId: $doorId, name: $name, officeMode: $officeMode) {
      hardwareIdentifier
      id
      name
      type
      batteryWarningLevel
      officeMode {
        ... on WeekSchedule {
          weekDays {
            dayName
            from
            to
          }
        }
      }
    }
  }
`;

export const DELETE_DOOR_BY_ID = gql`
  mutation DeleteDoorById($doorId: ID!) {
    deleteDoorById(doorId: $doorId)
  }
`;

export const SET_VISITOR = gql`
  mutation SetVisitor(
    $email: AWSEmail!
    $name: String!
    $visitorGroupExternalRefs: [String!]
    $expirationDate: AWSDateTime
  ) {
    setVisitor(
      email: $email
      name: $name
      visitorGroupExternalRefs: $visitorGroupExternalRefs
      expirationDate: $expirationDate
    ) {
      id
      name
      email
      mobileDevices {
        id
        isRegistered
        registrationToken
        registrationDate
        role
      }
      isEditable
      expirationDate
    }
  }
`;

export const SET_VISITOR_BY_ID = gql`
  mutation SetVisitorById(
    $visitorId: ID!
    $name: String!
    $visitorGroupExternalRefs: [String!]
    $expirationDate: AWSDateTime
    $visitorGroupMembership: [VisitorGroupMembershipInput!]!
  ) {
    setVisitorById(
      visitorId: $visitorId
      name: $name
      visitorGroupExternalRefs: $visitorGroupExternalRefs
      expirationDate: $expirationDate
      visitorGroupMembership: $visitorGroupMembership
    ) {
      id
      name
      email
      mobileDevices {
        id
        isRegistered
        registrationToken
        registrationDate
        role
      }
      isEditable
      expirationDate
    }
  }
`;

export const ADD_VISITOR_GROUP = gql`
  mutation AddVisitorGroup($name: String!, $type: String!) {
    addVisitorGroup(name: $name, type: $type) {
      id
      name
      members {
        id
        name
        email
        mobileDevices {
          id
          isRegistered
          registrationToken
          registrationDate
          role
        }
        isEditable
        expirationDate
      }
      type
      externalRef
    }
  }
`;

export const ADD_VISITOR_GROUP_WITH_RETAIL = gql`
  mutation AddVisitorGroupWithRetail($name: String!, $type: String!, $maxNumberOfMembers: Int) {
    addVisitorGroup(name: $name, type: $type, maxNumberOfMembers: $maxNumberOfMembers) {
      id
      name
      members {
        id
        name
        email
        mobileDevices {
          id
          isRegistered
          registrationToken
          registrationDate
          role
        }
        isEditable
        expirationDate
        isAdmin
      }
      type
      externalRef
      maxNumberOfMembers
    }
  }
`;

export const UPDATE_VISITOR_GROUP = gql`
  mutation UpdateVisitorGroup($visitorGroupId: ID!, $name: String!) {
    updateVisitorGroup(visitorGroupId: $visitorGroupId, name: $name) {
      id
      name
      members {
        id
        name
        email
        mobileDevices {
          id
          isRegistered
          registrationToken
          registrationDate
          role
        }
        isEditable
        expirationDate
        isAdmin
      }
      type
      externalRef
    }
  }
`;

export const UPDATE_VISITOR_GROUP_WITH_RETAIL = gql`
  mutation UpdateVisitorGroupWithRetail($visitorGroupId: ID!, $name: String!, $maxNumberOfMembers: Int) {
    updateVisitorGroup(visitorGroupId: $visitorGroupId, name: $name, maxNumberOfMembers: $maxNumberOfMembers) {
      id
      name
      members {
        id
        name
        email
        mobileDevices {
          id
          isRegistered
          registrationToken
          registrationDate
          role
        }
        isEditable
        expirationDate
        isAdmin
        visitorGroupMembership {
          visitorGroup {
            id
            type
          }
          role
        }
      }
      type
      externalRef
      maxNumberOfMembers
    }
  }
`;

export const SET_INSTALLER = gql`
  mutation SetInstaller($email: AWSEmail!, $name: String!) {
    setInstaller(email: $email, name: $name) {
      id
      name
      email
      mobileDevices {
        id
        isRegistered
        registrationToken
        registrationDate
        role
      }
      isEditable
      expirationDate
    }
  }
`;

export const UNSET_INSTALLER_BY_ID = gql`
  mutation UnsetInstallerById($visitorId: ID!) {
    unsetInstallerById(visitorId: $visitorId) {
      id
      name
      email
      mobileDevices {
        id
        isRegistered
        registrationToken
        registrationDate
        role
      }
      isEditable
      expirationDate
    }
  }
`;

export const SET_IS_ADMIN_FOR_GROUP = gql`
  mutation SetIsAdminForGroup($visitorGroupId: ID!, $isAdmin: Boolean!) {
    setIsAdminForGroup(visitorGroupId: $visitorGroupId, isAdmin: $isAdmin) {
      id
    }
  }
`;

export const SET_IS_QR_CODE_VISIT_INVITER_FOR_GROUP = gql`
  mutation SetIsQrCodeVisitInviterForGroup($visitorGroupId: ID!, $isQrCodeVisitInviter: Boolean!) {
    setIsQrCodeVisitInviterForGroup(visitorGroupId: $visitorGroupId, isQrCodeVisitInviter: $isQrCodeVisitInviter) {
      id
    }
  }
`;

export const UPDATE_ACCESS_GRANT_WITH_IS_OFFICE_MODE_ENABLED = gql`
  mutation SetAccessGrantsIsOfficeModeEnabled($accessGrantId: ID!, $isOfficeModeEnabled: Boolean!) {
    setAccessGrantsIsOfficeModeEnabled(accessGrantId: $accessGrantId, isOfficeModeEnabled: $isOfficeModeEnabled) {
      id
      isOfficeModeEnabled
    }
  }
`;

export const ADD_LOCATION = gql`
  mutation AddLocation($location: LocationInput!) {
    addLocation(location: $location) {
      id
      name
      doors {
        id
        name
        hardwareIdentifier
        batteryWarningLevel
      }
    }
  }
`;

export const UPDATE_LOCATION = gql`
  mutation UpdateLocation($id: ID!, $location: LocationInput!) {
    updateLocation(id: $id, location: $location) {
      id
      name
      doors {
        id
        name
        hardwareIdentifier
        batteryWarningLevel
      }
    }
  }
`;

export const DELETE_LOCATION = gql`
  mutation DeleteLocation($id: ID!) {
    deleteLocation(id: $id) {
      id
    }
  }
`;

export const UPDATE_DOOR_WITH_LOCATIONS = gql`
  mutation UpdateDoorWithLocations(
    $doorId: ID!
    $locationIds: [ID!]
    $name: String!
    $officeMode: UpdateDoorOfficeModeInput
  ) {
    updateDoor(doorId: $doorId, locationIds: $locationIds, name: $name, officeMode: $officeMode) {
      hardwareIdentifier
      id
      locations {
        id
        name
      }
      name
      batteryWarningLevel
      officeMode {
        ... on WeekSchedule {
          weekDays {
            dayName
            from
            to
          }
        }
      }
    }
  }
`;

export const ASSIGN_TO_ACCESS_GRANTS = gql`
  mutation AssignToAccessGrants($accessGrantIds: [ID!]!, $doorIds: [ID!]!, $locationIds: [ID!]!) {
    assignToAccessGrants(accessGrantIds: $accessGrantIds, doorIds: $doorIds, locationIds: $locationIds) {
      id
      accessSchedule {
        ... on WeekSchedule {
          weekDays {
            dayName
            from
            to
          }
        }
      }
      doors {
        hardwareIdentifier
        id
        locations {
          id
          name
        }
        name
        batteryWarningLevel
        officeMode {
          ... on WeekSchedule {
            weekDays {
              dayName
              from
              to
            }
          }
        }
      }
      locations {
        id
        name
        doors {
          id
          name
          hardwareIdentifier
          batteryWarningLevel
        }
      }
    }
  }
`;

export const UNASSIGN_TO_ACCESS_GRANTS = gql`
  mutation UnassignToAccessGrants($accessGrantIds: [ID!]!, $doorIds: [ID!]!, $locationIds: [ID!]!) {
    unassignFromAccessGrants(accessGrantIds: $accessGrantIds, doorIds: $doorIds, locationIds: $locationIds) {
      id
      accessSchedule {
        ... on WeekSchedule {
          weekDays {
            dayName
            from
            to
          }
        }
      }
      doors {
        hardwareIdentifier
        id
        locations {
          id
          name
        }
        name
        batteryWarningLevel
        officeMode {
          ... on WeekSchedule {
            weekDays {
              dayName
              from
              to
            }
          }
        }
      }
      locations {
        id
        name
        doors {
          id
          name
          hardwareIdentifier
          batteryWarningLevel
        }
      }
    }
  }
`;

export const ACCEPT_LEGAL_DOCUMENTS = gql`
  mutation AcceptLegalDocuments($acceptedLegalDocuments: AcceptedLegalDocuments!) {
    acceptLegalDocuments(acceptedLegalDocuments: $acceptedLegalDocuments) {
      ... on AgreementRejected {
        reason
      }
      ... on BasicTenant {
        tenantId
        name
        onboardingStep
        additionalData
      }
    }
  }
`;

export const VERIFY_ACCOUNT = gql`
  mutation VerifyAccount($email: AWSEmail!, $code: String!) {
    verifyAccount(email: $email, code: $code) {
      tenantId
      name
      onboardingStep
      additionalData
    }
  }
`;

export const CHOOSE_PROVIDER = gql`
  mutation ChooseProvider($provider: Provider!) {
    onboardingChooseProvider(provider: $provider) {
      tenantId
      name
      onboardingStep
      additionalData
    }
  }
`;

export const GO_BACK_ONE_ONBOARDING_STEP = gql`
  mutation GoBackOneOnboardingStep {
    goBackOneOnboardingStep {
      tenantId
      name
      onboardingStep
    }
  }
`;

export const RESEND_VERIFICATION_CODE = gql`
  mutation ResendVerificationCode($email: AWSEmail!) {
    resendVerificationCode(email: $email)
  }
`;

export const REGISTER_AZURE_TENANT = gql`
  mutation RegisterAzureTenant($input: RegisterAzureTenantInput!) {
    registerAzureTenant(input: $input) {
      tenantId
    }
  }
`;

export const ADD_REST_API_KEY = gql`
  mutation AddRestApiKey($description: String!) {
    addRestApiKey(description: $description) {
      apiKey
      createdAt
      description
      id
    }
  }
`;

export const UPDATE_REST_API_KEY = gql`
  mutation UpdateRestApiKey($id: ID!, $description: String!) {
    updateRestApiKey(id: $id, description: $description) {
      apiKey
      createdAt
      description
      id
    }
  }
`;

export const DELETE_REST_API_KEY = gql`
  mutation DeleteRestApiKey($id: ID!) {
    deleteRestApiKey(id: $id)
  }
`;

export const SET_MFA_PREFERENCE = gql`
  mutation SetMfaPreference($emailMfaEnabled: Boolean!) {
    setMfaPreference(emailMfaEnabled: $emailMfaEnabled) {
      emailMfaEnabled
    }
  }
`;

export const BLOCK_NFC_CARD = gql`
  mutation BlockNfcCard($uuid: ID!, $reason: String!) {
    blockNfcCard(uuid: $uuid, reason: $reason) {
      uuid
      name
      updateRequired
      assignment {
        expiryDate
        expired
        blocked {
          since
          reason
        }
        visitor {
          id
          expirationDate
          name
        }
        visitorName
      }
    }
  }
`;
